export const FILTER_CATEGORIES = {
  REGION: "region",
  LANGUAGE: "language",
  PLATFORM: "platform",
  RANK: "rank",
  SPECIALTY: "specialty",
  PRICE: "price",
}



// WEBPACK FOOTER //
// ./src/store/coaching/widget/coach-filters/coach-filters.constants.js